import { Color } from './color';

export const FeatureType = {
	CASES: 'cases',
	AML: 'aml',
	FORMS: 'forms',
	PROOF_OF_ADDRESS: 'poa',
	ENTITY: 'entity',
	FLOWS: 'flows',
} as const;
export type FeatureType = (typeof FeatureType)[keyof typeof FeatureType];

/** Canonical product-area presentation shared by Hela and public surfaces. */
export const FeatureVisualData = {
	[FeatureType.CASES]: { color: Color.PURPLE, icon: 'portfolio' },
	[FeatureType.AML]: { color: Color.ORANGE, icon: 'member-search' },
	[FeatureType.FORMS]: { color: Color.EMERALD, icon: 'form' },
	[FeatureType.PROOF_OF_ADDRESS]: { color: Color.CYAN, icon: 'calculator-bill' },
	[FeatureType.ENTITY]: { color: Color.RED, icon: 'file-user' },
	[FeatureType.FLOWS]: { color: Color.ROSE, icon: 'workflow-setting' },
} as const;
